export * from './fonts';
export * from './palette';
export * from './pinnedStreamPosition';
export * from './spacing';

export enum СssSetNaming {
    SPACING = 'spacing',
    PALETTE = 'palette',
    PINNED_STREAM_POSITION = 'pinnedStreamPosition',
}
